import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { PaycheckFrequency } from './paycheck-frequency.interface';

export class PaycheckFrequencyService {
   async getPaycheckFrequencies() {
      return await http
         .get<PaginatedResponse<PaycheckFrequency>>(`/paycheck-frequencies`, cacheFirstConfig)
         .then((response) => response.data.data);
   }
}
